export const TESTIMONIAL_INNER_CONTAINER_ONE =
    "max-w-full md:max-w-[60%]  mx-2 md:mx-auto ";
export const TESTIMONIAL_INNER_CONTAINER_TWO = " max-w-full  lg:mx-auto  ";
